import React, { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import { useScrollPause } from '@components/helper/hooks/useScrollPause';
import NewSectionTitle from '@components/shared/NewSectionTitle';
import businessIcon from '@assets/icons/placement-page/bussiness.svg';
import buildingIcon from '@assets/icons/placement-page/building.svg';
import employeeIcon from '@assets/icons/placement-page/employee-man.svg';
import thumbnailImage from '@assets/placementpage-images/thumbnail.png';
import useMediaQuery from '@utils/hooks/useMediaQuery';
// import testimonialvideo from '@assets/placementpage-images/testimonial-video.mp4'

const VideosCarousel = ({ placementPage, placementStats, videosData }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [testimonials, setTestimonials] = useState([]);

  const isMobile = useMediaQuery('(max-width: 767.98px)');

  // Handle navigation
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1));
  };
  // Video testimonials data
  // const testimonials = [
  //   {
  //     id: 1,
  //     name: 'Devan Rai',
  //     position: 'Software Developer at Amazon',
  //     videoUrl: 'assets/placementpage-images/testimonial-video.mp4',
  //     thumbnailUrl: thumbnailImage,
  //   },
  //   {
  //     id: 2,
  //     name: 'Devan Rai',
  //     position: 'Software Developer at Amazon',
  //     videoUrl: 'assets/placementpage-images/testimonial-video.mp4',
  //     thumbnailUrl: thumbnailImage,
  //   },
  //   {
  //     id: 3,
  //     name: 'Devan Rai',
  //     position: 'Software Developer at Amazon',
  //     videoUrl: 'assets/placementpage-images/testimonial-video.mp4',
  //     thumbnailUrl: thumbnailImage,
  //   },
  //   {
  //     id: 4,
  //     name: 'Devan Rai',
  //     position: 'Software Developer at Amazon',
  //     videoUrl: 'assets/placementpage-images/testimonial-video.mp4',
  //     thumbnailUrl: thumbnailImage,
  //   },
  //   {
  //     id: 5,
  //     name: 'Devan Rai',
  //     position: 'Software Developer at Amazon',
  //     videoUrl: 'assets/placementpage-images/testimonial-video.mp4',
  //     thumbnailUrl: thumbnailImage,
  //   },
  //   {
  //     id: 6,
  //     name: 'Devan Rai',
  //     position: 'Software Developer at Amazon',
  //     videoUrl: 'assets/placementpage-images/testimonial-video.mp4',
  //     thumbnailUrl: thumbnailImage,
  //   },
  //   {
  //     id: 7,
  //     name: 'Devan Rai',
  //     position: 'Software Developer at Amazon',
  //     videoUrl: 'assets/placementpage-images/testimonial-video.mp4',
  //     thumbnailUrl: thumbnailImage,
  //   },
  //   {
  //     id: 8,
  //     name: 'Devan Rai',
  //     position: 'Software Developer at Amazon',
  //     videoUrl: 'assets/placementpage-images/testimonial-video.mp4',
  //     thumbnailUrl: thumbnailImage,
  //   },
  //   {
  //     id: 9,
  //     name: 'Devan Rai',
  //     position: 'Software Developer at Amazon',
  //     videoUrl: 'assets/placementpage-images/testimonial-video.mp4',
  //     thumbnailUrl: thumbnailImage,
  //   },
  // ];
  const visibleStats = placementStats?.OrgSizeBreakup;

  const stats = visibleStats?.map((item, index) => {
    // Clean the percentage string (e.g., "35%" -> 35)
    const cleanedPercentage = parseInt(item?.Percentage?.toString()?.replace('%', ''));

    // Reuse existing icons in the same order
    const icons = [businessIcon, buildingIcon, employeeIcon];

    return {
      id: index + 1,
      percentage: cleanedPercentage,
      text: `Placed in ${item.OrgSize}`,
      icon: icons[index] || businessIcon, // fallback if more than 3
    };
  });

  // State to track which video is currently playing
  const [activeVideo, setActiveVideo] = useState(null);
  const videoRefs = useRef({});
  const scrollContainerRef = useScrollPause();
  const containerRef = useRef(null);

  // Function to handle mouse enter on video card
  const handleMouseEnter = (id) => {
    setActiveVideo(id);
    if (videoRefs.current[id]) {
      videoRefs.current[id].volume = 1;
      videoRefs.current[id].play();
    }
  };

  // Function to handle mouse leave on video card
  const handleMouseLeave = (id) => {
    setActiveVideo(null);
    if (videoRefs.current[id]) {
      videoRefs.current[id].volume = 0;
      videoRefs.current[id].pause();
      videoRefs.current[id].currentTime = 0;
    }
  };

  // Function to handle mouse enter or click on video card (for mobile)
  const handlePlayVideo = (id) => {
    setActiveVideo(id);
    Object.keys(videoRefs.current).forEach((key) => {
      if (key !== String(id) && videoRefs.current[key]) {
        videoRefs.current[key].pause();
        videoRefs.current[key].currentTime = 0;
      }
    });
    if (videoRefs.current[id]) {
      videoRefs.current[id].volume = 1;
      videoRefs.current[id].play();
    }
  };

  // Function to handle pause on mobile
  const handlePauseVideo = (id) => {
    setActiveVideo(null);
    if (videoRefs.current[id]) {
      videoRefs.current[id].pause();
      videoRefs.current[id].currentTime = 0;
    }
  };

  const calculateTransform = () => {
    // Card width is 70% of the container + 16px gap (8px on each side)
    // To center a card, we need to include an offset calculation
    const containerWidth = 100; // 100% of the container
    const cardWidth = 70; // 70% of the container
    const gapWidth = 2; // 16px represented as percentage of container (approximation)

    // Calculate how much to move left
    const baseTranslate = currentIndex * (cardWidth + gapWidth);

    // Calculate centering offset (to center the current card)
    const centeringOffset = (containerWidth - cardWidth) / 2;

    return `translateX(calc(-${baseTranslate}% + ${centeringOffset}%))`;
  };

  // Register video ref
  const registerVideoRef = (id, element) => {
    if (element) {
      videoRefs.current[id] = element;
    }
  };

  const convertToTestimonials = (apiData) => {
    const converted = [];

    // Convert hero students
    if (apiData.heroStudents) {
      apiData.heroStudents.forEach((student) => {
        converted.push({
          id: student.id,
          name: student.Name,
          position: student.Role,
          videoUrl: student.Video || '',
          thumbnailUrl: student.VideoThumbnail || '',
        });
      });
    }

    // Convert non-hero students (grouped by month)
    if (apiData.nonHeroStudents) {
      Object.keys(apiData.nonHeroStudents)?.forEach((month) => {
        apiData?.nonHeroStudents[month]?.forEach((student) => {
          if (!converted.find((t) => t.id === student.id)) {
            converted.push({
              id: student.id,
              name: student.Name,
              position: student.Role,
              videoUrl: student.Video || '',
              thumbnailUrl: student.VideoThumbnail || '',
            });
          }
        });
      });
    }

    return converted;
  };

  useEffect(() => {
    const convertedData = convertToTestimonials(videosData);
    setTestimonials(convertedData);
  }, []);

  // For mobile, filter testimonials with video
  const filteredTestimonials = testimonials?.filter((testimonial) => testimonial.videoUrl);

  return (
    <>
      {' '}
      {!isMobile ? (
        <div className="relative w-full overflow-hidden bg-black py-20 md:py-20">
          {/* Background blur effect container */}
          <div className="absolute inset-0 z-0">
            {/* Base dark background */}
            <div className="absolute inset-0 bg-black/90"></div>

            {/* Red blurred circle on the left side */}
            <div
              className="absolute left-0 top-0 bottom-0 w-2/3 rounded-full opacity-60"
              style={{
                backgroundColor: '#F00037',
                filter: 'blur(425px)',
                transform: 'translateX(-30%)',
                borderRadius: '329px',
              }}
            ></div>

            {/* Additional subtle dark gradient overlay from right */}
            <div className="absolute inset-0 bg-gradient-to-l from-black via-black/80 to-transparent"></div>
          </div>

          <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-8">
            <div className="flex flex-col md:flex-row md:justify-between md:gap-16">
              {/* Left side content */}
              <div className="mb-12 flex w-full flex-col text-white md:mb-0 md:w-1/3">
                <div className="mb-8">
                  <NewSectionTitle
                    text="Hear from those who"
                    highlightedText="Did It"
                    placementPage={placementPage}
                    videoCarousel={true}
                  />

                  <p className="mt-4 font-proxima-nova text-base leading-[150%] text-white">
                    Dreamers, hustlers, and go-getters, our students come from all walks of life.
                  </p>
                </div>

                {/* Stats with consistent spacing */}
                <div className="mt-8 flex flex-col space-y-12">
                  {stats?.map((stat) => (
                    <div key={stat.id} className="flex flex-col items-start">
                      <div className="flex items-baseline">
                        <span className="text-right font-proxima-nova text-[36px] font-semibold capitalize leading-none text-white">
                          {stat.percentage}
                        </span>
                        <span className="ml-1 font-proxima-nova text-[24px] font-normal capitalize leading-none text-white">
                          %
                        </span>
                      </div>
                      <div className="mt-1 flex items-center gap-2">
                        <p className="text-center font-proxima-nova text-[14px] font-normal capitalize leading-none text-white/80">
                          {stat.text}
                        </p>
                        <Image src={stat.icon} alt="" className="h-4 w-4" />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Right side video gallery */}

              <div className="relative w-full md:w-2/3">
                {/* Fade overlay at top */}
                <div className="pointer-events-none absolute top-0 left-0 right-0 z-20 h-16 bg-gradient-to-b from-black/80 to-transparent"></div>

                {/* Fade overlay at bottom */}
                <div className="pointer-events-none absolute bottom-0 left-0 right-0 z-20 h-16 bg-gradient-to-t from-black/80 to-transparent"></div>

                <div
                  ref={containerRef}
                  className="scrollbar-hide relative h-[600px] overflow-y-auto"
                >
                  {/* Scrolling container */}
                  <div
                    ref={scrollContainerRef}
                    className="animate-scroll-up absolute w-full"
                    style={{
                      animationDuration: '15s',
                      animationFillMode: 'forwards',
                      animationTimingFunction: 'linear',
                      animationIterationCount: 'infinite',
                    }}
                  >
                    {/* Video cards grid */}
                    <div className="ml-10 grid grid-cols-3 gap-x-0 gap-y-0 md:grid-cols-2 lg:grid-cols-3">
                      {' '}
                      {/* Reduced gaps */}
                      {testimonials
                        ?.filter((testimonial) => testimonial.videoUrl)
                        .map((testimonial, index) => (
                          <div
                            key={testimonial.id}
                            className={`relative transform cursor-pointer transition-all duration-300 hover:z-30 hover:scale-105 ${
                              index % 3 === 0 ? 'mt-4' : index % 3 === 1 ? 'mt-8' : 'mt-12'
                            }`} // Staggered positioning
                            onMouseEnter={() => handleMouseEnter(testimonial.id)}
                            onMouseLeave={() => handleMouseLeave(testimonial.id)}
                          >
                            {/* Card styling */}
                            <div
                              className="group relative flex h-[344px] w-[229px] flex-col items-start justify-end overflow-hidden rounded-xl p-0 shadow-lg"
                              style={{
                                boxShadow:
                                  activeVideo === testimonial.id
                                    ? '0 0 0 1px rgba(255, 255, 255, 0.3)'
                                    : '0 0 0 1px rgba(255, 255, 255, 0.2)',
                              }}
                            >
                              {/* Thumbnail image */}
                              <div
                                className={`absolute inset-0 transition-opacity duration-300 ${
                                  activeVideo === testimonial.id ? 'opacity-0' : 'opacity-100'
                                }`}
                              >
                                <Image
                                  src={testimonial.thumbnailUrl}
                                  alt={`${testimonial.name} thumbnail`}
                                  layout="fill"
                                  objectFit="cover"
                                  priority={index < 3}
                                />
                              </div>

                              {/* Video backdrop */}
                              <video
                                ref={(el) => registerVideoRef(testimonial.id, el)}
                                className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-300 ${
                                  activeVideo === testimonial.id ? 'opacity-100' : 'opacity-0'
                                }`}
                                src={testimonial.videoUrl}
                                playsInline
                                loop
                              />

                              {/* Default gradient overlay */}
                              <div className="via-gray-900/6 absolute inset-0 bg-gradient-to-b from-transparent to-[#161616] transition-opacity group-hover:opacity-0"></div>

                              {/* Hover gradient overlay with red tint */}
                              <div
                                className="via-gray-500/6 absolute inset-0 bg-gradient-to-b from-transparent to-[#F00037] opacity-0 transition-opacity group-hover:opacity-100"
                                style={{
                                  background:
                                    'linear-gradient(179deg, rgba(255, 255, 255, 0.00) 0.47%, rgba(145, 145, 145, 0.06) 42.92%, #F00037 97.64%, #F00037 97.64%)',
                                }}
                              ></div>

                              {/* Card border overlay */}
                              <div
                                className="pointer-events-none absolute inset-0 rounded-xl transition-opacity duration-300"
                                style={{
                                  boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.3)',
                                  opacity: activeVideo === testimonial.id ? 1 : 0,
                                }}
                              ></div>

                              {/* Play button overlay */}
                              <div
                                className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${
                                  activeVideo === testimonial.id ? 'opacity-0' : 'opacity-100'
                                }`}
                              >
                                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white bg-opacity-30">
                                  <div className="bg-red-600 flex h-8 w-8 items-center justify-center rounded-full">
                                    <svg
                                      className="h-4 w-4 fill-current text-white"
                                      viewBox="0 0 24 24"
                                    >
                                      <path d="M8 5v14l11-7z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>

                              {/* Content overlay */}
                              <div className="relative z-10 flex flex-col gap-1.5 p-5">
                                <h3 className="font-proxima-nova text-sm font-medium text-white">
                                  {testimonial.name}
                                </h3>
                                <p className="font-proxima-nova text-xs text-gray-300">
                                  {testimonial.position}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="relative w-full overflow-hidden bg-black py-20 md:py-20">
          <div className="absolute inset-0 z-0">
            {/* Base dark background */}
            <div className="absolute inset-0 bg-black/90"></div>

            {/* Red blurred circle on the left side */}
            <div
              className="absolute left-0 top-0 bottom-0 w-2/3 rounded-full opacity-60"
              style={{
                backgroundColor: '#F00037',
                filter: 'blur(425px)',
                transform: 'translateX(-30%)',
                borderRadius: '329px',
              }}
            ></div>

            {/* Additional subtle dark gradient overlay from right */}
            <div className="absolute inset-0 bg-gradient-to-l from-black via-black/80 to-transparent"></div>
          </div>

          <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-8">
            <div className="flex flex-col md:flex-row md:justify-between md:gap-16">
              <div className="mb-12 flex w-full flex-col text-white md:mb-0 md:w-1/3">
                <div className="mb-8">
                  <NewSectionTitle
                    text="Hear from those who"
                    highlightedText="Did It"
                    placementPage={placementPage}
                    videoCarousel={true}
                  />

                  <p className="mt-4 font-proxima-nova-bold text-base leading-[150%] text-white">
                    Dreamers, hustlers, and go-getters, our students come from all walks of life.
                  </p>
                </div>

                {/* Stats with consistent spacing */}
                <div className="mt-8 flex flex-col space-y-12">
                  {stats?.map((stat) => (
                    <div key={stat.id} className="flex flex-col items-start">
                      <div className="flex items-baseline">
                        <span className="text-right font-proxima-nova text-[36px] font-semibold capitalize leading-none text-white">
                          {stat.percentage}
                        </span>
                        <span className="ml-1 font-proxima-nova text-[24px] font-normal capitalize leading-none text-white">
                          %
                        </span>
                      </div>
                      <div className="mt-1 flex items-center gap-2">
                        <p className="text-center font-proxima-nova text-[14px] font-normal capitalize leading-none text-white/80">
                          {stat.text}
                        </p>
                        <Image src={stat.icon} alt="" className="h-4 w-4" />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="relative mx-auto w-full max-w-3xl overflow-hidden py-14">
                <div
                  className={`mr-[29px] flex ${filteredTestimonials.length === 1 ? 'justify-center' : ''} transition-transform duration-500`}
                  style={
                    filteredTestimonials.length === 1
                      ? {}
                      : {
                          transform: calculateTransform(),
                        }
                  }
                >
                  {filteredTestimonials.map((testimonial, index) => (
                    <div
                      key={testimonial.id}
                      className="relative mx-2 w-[70%] flex-shrink-0"
                    >
                      {/* Card */}
                      <div
                        className={`relative flex h-[344px] w-full flex-col items-start justify-end overflow-hidden rounded-xl shadow-lg ${
                          activeVideo === testimonial?.id || currentIndex === index
                            ? 'border-2 border-white'
                            : ''
                        }`}
                      >
                        {/* Thumbnail (show if not playing) */}
                        {activeVideo !== testimonial.id && (
                          <div
                            className="absolute inset-0 z-10"
                            onClick={() => handlePlayVideo(testimonial.id)}
                          >
                            <Image
                              src={testimonial.thumbnailUrl}
                              alt={`${testimonial.name} thumbnail`}
                              layout="fill"
                              objectFit="cover"
                            />
                          </div>
                        )}
                        {/* Video (show if playing) */}
                        <video
                          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-300 ${activeVideo === testimonial.id ? 'opacity-100 z-20' : 'opacity-0'}`}
                          src={testimonial.videoUrl}
                          ref={(el) => registerVideoRef(testimonial.id, el)}
                          playsInline
                          loop
                          onClick={() => handlePauseVideo(testimonial.id)}
                        />
                        {/* Gradient Overlay */}
                        {activeVideo === testimonial.id ||
                          (currentIndex === index && (
                            <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#F00037]/40"></div>
                          ))}
                        {/* Content */}
                        <div className="relative z-30 p-4">
                          <h3 className="font-proxima-nova text-sm font-medium text-white">
                            {testimonial.name}
                          </h3>
                          <p className="font-proxima-nova text-xs text-white">
                            {testimonial.position}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Navigation Buttons */}
                <div className="absolute bottom-0 right-4 flex space-x-2">
                  <button
                    disabled={currentIndex === 0}
                    onClick={handlePrev}
                    className="flex h-10 w-10 items-center justify-center rounded-full bg-white shadow-md"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-[#F00037]"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15 19l-7-7 7-7"
                      />
                    </svg>
                  </button>
                  <button
                    disabled={currentIndex === testimonials.length - 2}
                    onClick={handleNext}
                    className="flex h-10 w-10 items-center justify-center rounded-full bg-white shadow-md"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-[#F00037]"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VideosCarousel;
